export var BankAccountOperationStatus;
(function (BankAccountOperationStatus) {
    BankAccountOperationStatus["Unreconciled"] = "UNRECONCILED";
    BankAccountOperationStatus["Reconciled"] = "RECONCILED";
})(BankAccountOperationStatus || (BankAccountOperationStatus = {}));
export var BankAccountOperationSource;
(function (BankAccountOperationSource) {
    BankAccountOperationSource["BankFeed"] = "BANK_FEED";
    BankAccountOperationSource["Manual"] = "MANUAL";
})(BankAccountOperationSource || (BankAccountOperationSource = {}));
export var BankReconciliationActionType;
(function (BankReconciliationActionType) {
    BankReconciliationActionType["ReconciliationCreated"] = "ReconciliationCreated";
})(BankReconciliationActionType || (BankReconciliationActionType = {}));
export var CurrencySaleRevaluationType;
(function (CurrencySaleRevaluationType) {
    CurrencySaleRevaluationType["CurrencySaleGain"] = "CURRENCY_SALE_GAIN";
    CurrencySaleRevaluationType["CurrencySaleLoss"] = "CURRENCY_SALE_LOSS";
})(CurrencySaleRevaluationType || (CurrencySaleRevaluationType = {}));
export var PaymentActivity;
(function (PaymentActivity) {
    PaymentActivity["Created"] = "CREATED";
    PaymentActivity["PaymentReceived"] = "PAYMENT_RECEIVED";
    PaymentActivity["PrepaymentReceived"] = "PREPAYMENT_RECEIVED";
    PaymentActivity["PrepaymentResolved"] = "PREPAYMENT_RESOLVED";
})(PaymentActivity || (PaymentActivity = {}));
//# sourceMappingURL=index.js.map